import { BeanUsuario } from './BeanUsuario';

export class BeanContestationAnswer{
    constructor(
      public recoIdCdRespostaContestacao: number,
      public contIdCdContestacao :number,
      public recoTxRespostaContestacao :string,
      public recoDsArquivo :string,
      public usuaIdCdUsuario :number,
      public recoDhRegistro :string,
      public recoDsNomeArquivo :string,
      public userRespostaContestacao : BeanUsuario,
      public recoInProcedente :string,
      
    ){}
  }